import React, { useState } from "react"
import VideoSlider from "components/video/VideoSlider"
import { ShortsVideo } from "types/event"



interface IVideos {
    videos: ShortsVideo[]
}
export const RenderStory = ({
    videos
}: IVideos) => {

    const [runningVideo, setRunningVideo] = useState<string | undefined>(undefined)


    return videos && videos.length > 0
        && videos.map((video, index) => (
            <div
                key={`${index}`}
                className={`   lg:max-w-[1230px] `}
            >
                <VideoSlider runningVideo={runningVideo}
                    setRunningVideo={setRunningVideo} video={video} />
            </div>
        ))
}

export default RenderStory